'use es6'; // Taken from UIComponents

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import memoizeOne from 'react-utils/memoizeOne';
import ShareScrollElement from 'UIComponents/decorators/ShareScrollElement';
import UILayer from 'UIComponents/layer/UILayer';
import MobilePanelTransition from './internal/MobilePanelTransition';
import { getMobilePanelTransitionProps } from './internal/MobilePanelUtils';
import MobileLayer from './MobileLayer';
const MobilePanelGlobalStyle = createGlobalStyle(_t || (_t = _`
  #hubspot-messages-iframe-container {
    z-index: 0 !important;
  }
  body {
    top: ${0};                                                                                                                                 
  }
`), `-${window.pageYOffset}px`);
const StyledPanelWrapper = styled.div.withConfig({
  displayName: "MobilePanel__StyledPanelWrapper",
  componentId: "sc-1i0mcxt-0"
})(["&&{display:flex;flex-direction:row;background:", ";height:100%;min-width:100%;width:100%;overflow-x:hidden;overflow-y:auto;z-index:", ";}"], OLAF, URANUS_LAYER);
const StyledPanelInner = styled.div.withConfig({
  displayName: "MobilePanel__StyledPanelInner",
  componentId: "sc-1i0mcxt-1"
})(["display:flex;flex-direction:column;padding-top:40px;min-height:100%;width:100%;"]);

class MobilePanel extends Component {
  constructor(props) {
    super(props);
    this._getTransitionProps = memoizeOne((...args) => {
      return Object.assign({}, getMobilePanelTransitionProps(...args), {
        duration: 100
      });
    });
  }

  render() {
    const _this$props = this.props,
          {
      align,
      animate,
      children,
      onOpenStart,
      onOpenComplete,
      onCloseStart,
      onCloseComplete,
      open,
      rootNode
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["align", "animate", "children", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "open", "panelKey", "rootNode"]);

    const renderedPanel = /*#__PURE__*/_jsx(StyledPanelWrapper, Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(StyledPanelInner, {
        children: children
      })
    }));

    return open ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(MobilePanelGlobalStyle, {}), /*#__PURE__*/_jsx(MobileLayer, {
        "data-layer-for": "Panel",
        offsetTop: "0",
        rootNode: rootNode,
        Transition: MobilePanelTransition,
        transitionProps: this._getTransitionProps(onOpenStart, onOpenComplete, onCloseStart, onCloseComplete, align, animate),
        children: renderedPanel
      })]
    }) : null;
  }

}

MobilePanel.propTypes = {
  animate: PropTypes.bool.isRequired,
  align: PropTypes.oneOf(['bottom', 'left', 'right', 'top']).isRequired,
  children: PropTypes.node,
  onCloseComplete: PropTypes.func,
  onCloseStart: PropTypes.func,
  onOpenComplete: PropTypes.func,
  onOpenStart: PropTypes.func,
  open: PropTypes.bool,
  panelClassName: PropTypes.string,
  rootNode: UILayer.propTypes.rootNode,
  panelKey: PropTypes.string
};
MobilePanel.defaultProps = {
  align: 'right',
  animate: true,
  width: '100%',
  _dontMakeNewLayer: false
};
MobilePanel.displayName = 'MobilePanel';
export default ShareScrollElement(MobilePanel);